// removed by extract-text-webpack-plugin
module.exports = {"payment_edit":"payment_edit__1VOnY"};


//////////////////
// WEBPACK FOOTER
// ./routes/payments/edit/style.scss
// module id = 8++I
// module chunks = 3